"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// For an explanation of why `ThisTypedComponentOptionsWithRecordProps`
// is used here, see the `Placeholder.ts` component file.
exports.SitecoreContext = {
    props: {
        componentFactory: {
            // Hopefully this PR will negate having to cast the formatter prop
            // to PropOptions<any>: https://github.com/vuejs/vue/pull/6856
            type: Function,
            default: undefined,
        },
    },
    provide: function () {
        return {
            injectedComponentFactory: this.componentFactory,
        };
    },
    render: function () {
        return this.$slots && this.$slots.default[0];
    },
};
